import {windowSize} from "../utils/window-size";
import {debounce} from "../utils/debounce";

export const validity = {
    mixins: [windowSize],
    data: () => ({
        valid: false,
        termsAccepted: false,
        initialValidity: true,
        validationMessages: [],
        formVisibility: false
    }),
    watch: {
        'form.errors'() {
            if (this.form.errors.any()) {
                setTimeout(() => this.form.errors.clear(), 1000)
            }
        },
        isMobile(mobile) {
            if (!this.formVisibility) {
                this.formVisibility = !mobile
            }
        }
    },
    computed: {
        validationMessage() {
            return this.validationMessages.join(', ')
        },
        notValid() {
            return !this.valid
        },
        buttonValidity() {
            return {
                'class': {
                    'bg-dark-5 disabled': this.notValid || !this.termsAccepted,
                    'btn btn-success btn-block': true
                },
                disabled: this.notValid || !this.termsAccepted,
                type: "button"
            }
        },
        formEvents() {
            return {
                keyup: debounce(this.checkValidity),
                click: debounce(this.checkValidity),
                mouseover: debounce(this.checkValidity),
                change: () => {
                    this.form.errors.clear()
                    this.checkValidity()
                },
            }
        },
    },
    methods: {
        checkValidity: debounce(function () {
            if (this.$refs.form)
            {
                this.valid = this.$refs.form && this.$refs.form.checkValidity() && !this.form.errors.any()

                if (!this.valid) {
                    for (let node of this.$refs.form.querySelectorAll(":invalid")) {
                        this.validationMessages.push(node.validationMessage)
                    }
                } else this.validationMessages = []

                this.valid = this.valid && !this.form.errors.any()
            }
        }),
        showForm: debounce(function () {
            this.formVisibility = true
        }, 700)
    },
    mounted() {
        this.checkValidity()

        this.formVisibility = !this.isMobile
    }
}
